import { render, staticRenderFns } from "./BarCodeRulesList.vue?vue&type=template&id=1b80eb96&"
import script from "./BarCodeRulesList.vue?vue&type=script&lang=js&"
export * from "./BarCodeRulesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports